var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-component",class:[`app-${_vm.$route.name}`],attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view')],1),_c('Tool',{staticClass:"tool-wrapper"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }